import * as React from 'react';
import { ImageObject } from '../common';
import GalleryImageProps from './type';
import './styles.scss';

const GalleryImage = ({
  image,
  isLight,
}: GalleryImageProps) => (
  <div className={`gallery-image ${isLight && 'gallery-image--light'}`}>
    <div className="gallery-image__image">
      <ImageObject image={image} />
    </div>
    {Boolean(image.description && image.description !== '') && (
      <div className="gallery-image__details">
        <div className="gallery-image__description">
          {image.description}
        </div>
        {image.credit && (
          <div className="gallery-image__copyright">
            &copy;&nbsp;
            {image.credit}
          </div>
        )}
      </div>
    )}
  </div>
);

export default GalleryImage;
